export default `<svg aria-hidden="true" style="margin: 0 6px;" fill="var(--primary-color)" height="12" width="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.583 7L7.992 2.409A1 1 0 1 1 9.407.993l6.3 6.3a1 1 0 0 1 0 1.414l-6.3 6.3a1 1 0 0 1-1.415-1.416L12.583 9H1a1 1 0 1 1 0-2z" fill-rule="evenodd"></path>
</svg>`;
